const ALERT = {
  CREATE_GAME_CHARACTER: '게임에 접속해 캐릭터를 먼저 생성해주세요.',

  NO_SAVED_STATS: `저장한 스탯 세팅이 없습니다.
세팅한 스탯 저장 후 다시 진행해주세요.`,

  FAIL_LOAD_MY_CHARACTERS: '현재 내 캐릭터 스탯 정보를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.',

  FAIL_LOAD_SAVED_EQUIP: '현재 저장된 장비 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.',

  FAIL_LOAD_SAVED_STAT: '현재 저장된 스탯 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.',

  SAVE_EQUIP_LIMIT: `장비 세팅 저장은 계정당 최대 6개까지 가능합니다.
새 세팅 결과 저장을 원한다면 기존 저장 내용 삭제 후 이용해주세요.
장비 세팅을 계속 진행하시겠습니까?`,

  SAVE_EQUIP_LIMIT_SIMPLE: '장비 세팅 저장은 계정당 최대 6개까지 가능합니다.',

  INPUT_SEARCH_KEYWORD: '검색어를 입력해주세요.',
  FAIL_LOAD_EQUIP_ITEMS: '현재 장비 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.',

  FAIL_LOAD_STATS_REFLECT_EQUIP_ITEMS: '현재 장비 착용 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.',

  FAIL_SAVE_EQUIP: '현재 장비 저장을 할 수 없습니다. 잠시 후, 다시 시도해주세요.',

  RESET_ALL_EQUIPS: '입력하신 장비 정보가 초기화 됩니다. 진행 하시겠습니까?',

  TRY_DELETE_EQUIP: (data = {memo: ''}) => {
    const memoTpl = (data.memo) ? `${data.memo} ` : '';
    return memoTpl + '장비 세팅을 삭제하시겠습니까?';
  },

  FAIL_DELETE_EQUIP: '현재 장비 삭제를 할 수 없습니다. 잠시 후, 다시 시도해주세요.',

  FAIL_LOAD_ITEM_PRICE: '장비 시세 정보를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
};

const MSG = {
  NO_SAVED_EQUIP_SETTING_TITLE: '저장된 제목이 없습니다.',
  PRICE_LOGIN_REQUIRED: '로그인 필요',

  IMPOSSIBLE_WEAR_ARROW: '장비 슬롯에 착용할 수 없는 아이템입니다.',
  IMPOSSIBLE_WEAR_TWOHAND_SWORD_WHEN_WEAR_SHIELD: '양손 무기와 방패는 동시에 착용이 불가합니다.', // 방패 착용시에는, 양손 무기나 양손 창의 착용 불가. or 양손 무기 착용시에는 방패 착용 불가.
  IMPOSSIBLE_MUST_WEAR_ONEHAND_IN_SECOND_SWORD_SLOT: '한손 둔기만 착용이 가능합니다.', // '슬롯 2에는 한손 무기만 착용 가능. - 한손 무기만 착용 가능.'
  IMPOSSIBLE_WEAR_DOUBLE_ONEHAND_WHEN_WEAR_SHIELD_OR_GUARD: '방패, 가더 착용 중에는 무기를 쌍수로 착용할 수 없습니다.',
  IMPOSSIBLE_WEAR_TWOHAND_WHEN_EXIST_SECOND_SWORD: '한손 둔기만 쌍수로 착용이 가능합니다.', // 슬롯 2에 무기 착용하고 있을 때는, 양손 무기 착용 불가
  IMPOSSIBLE_WEAR_SPEAR_WHEN_EXIST_SECOND_SWORD: '창은 쌍수로 착용이 불가합니다.', // 두번째 무기 슬롯에 무기 착용시, 창 착용 불가.
  IMPOSSIBLE_WEAR_ONEHAND_WHEN_TWOHAND_IN_FIRST_SWORD_SLOT: '한손 둔기만 쌍수로 착용이 가능합니다.',
  IMPOSSIBLE_WEAR_NOT_BLUNT_WHEN_BLUNT_IN_SECOND_SWORD: '한손 둔기만 쌍수로 착용이 가능합니다.', // 슬롯 2에 둔기 장착 상태에서, 슬롯 1에 둔기가 아닌 무기를 장착 시도.
  IMPOSSIBLE_MUST_BLUNT_IN_SECOND_SWORD: '한손 둔기만 쌍수로 착용이 가능합니다.', // 슬롯 2에는 둔기만 착용 가능. 슬롯 2에 둔기가 아닌 무기 착용 시도
  IMPOSSIBLE_WEAR_BLUNT_WHEN_NOT_BLUNT_IN_FIRST_SWORD: '한손 둔기만 쌍수로 착용이 가능합니다.', // 슬롯 1이 둔기가 아닌 무기 장착 상태에서, 슬롯 2에 둔기 착용 시도
  IMPOSSIBLE_WEAR_GUARD_WHEN_EXIST_SHIELD: '방패와 가더는 동시에 착용할 수 없습니다.', // 방패 착용 상태에서는 가더를 착용할 수 없습니다.
  IMPOSSIBLE_WEAR_SHIELD_WHEN_EXIST_GUARD: '방패와 가더는 동시에 착용할 수 없습니다.', // 가더 착용 상태에서는 방패를 착용할 수 없습니다.
  IMPOSSIBLE_WEAR_SWORD_WHEN_WEAR_SPEAR: '창은 쌍수로 착용이 불가합니다.',
  IMPOSSIBLE_WEAR_EQUAL_RING: '동일한 반지 및 이벤트, 유료 반지는 최대 2개까지 착용 가능합니다.',
  IMPOSSIBLE_WEAR_MORE_EVENT_OR_CASH_RING: '동일한 반지 및 이벤트, 유료 반지는 최대 2개까지 착용 가능합니다.',
  IMPOSSIBLE_WEAR_EXPAND_RING_SLOT: '슬롯이 확장되지 않아 아이템을 착용할 수 없습니다.',
  IMPOSSIBLE_WEAR_EQUAL_EARRING: '동일한 귀걸이를 동시에 착용할 수 없습니다.',
  IMPOSSIBLE_WEAR_EXPAND_EARRING_SLOT: '슬롯이 확장되지 않아 아이템을 착용할 수 없습니다.'
};

export {
  ALERT,
  MSG
};


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/model/msg/equip.js